<template>
  <div
    class="benefit-wrap"
    :class="{ 'benefit-image': type !== 'benefitImage' }"
  >
    <div class="title" v-if="type !== 'benefitImage'">
      {{ item.name }}
    </div>
    <div class="desc" v-if="type !== 'benefitImage'">
      {{ item.desc }}
    </div>
    <div
      class="content"
      :style="{ background: `url(${item.display_img_url})` }"
    >
      <div class="action">
        <div class="amount">剩余{{ amount }}次</div>
        <div
          class="btn"
          :data-type="item.productInfo[0].benefit_type"
          @click="handleDraw"
          :class="{ disabled: disable }"
          v-ans="{
            event_id: 'benefit_list_click',
            namespace,
            benefit_type: item.productInfo[0].benefit_type,
          }"
        >
          {{ disable ? "已领完" : "立即领取" }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from "@vue/composition-api";

import { useRouter } from "@/components/use/base";

export default defineComponent({
  name: "benefit",
  props: ["item", "card", "type", "namespace"],

  setup(props) {
    const router = useRouter();

    const amount = computed(() => {
      const benefitList = props.card.benefit_list;
      const productInfo = props.item.productInfo || [];
      if (props.type === "benefit" || props.type === "benefitImage") {
        const benefitType = productInfo[0].benefit_type;
        const benefit = benefitList.find((v) => v.type === benefitType);
        return benefit?.amount + benefit?.amount_reserved || 0;
      } else {
        const amountList = productInfo.map((value) => {
          const benefitType = value.benefit_type;
          const benefit = benefitList.find((v) => v.type === benefitType);
          return benefit?.amount + benefit?.amount_reserved || 0;
        });
        return amountList.reduce((a, b) => a + b, 0);
      }
    });

    const disable = computed(() => {
      return amount.value <= 0;
    });

    const handleDraw = () => {
      if (disable.value) return;
      if (props.type === "benefit" || props.type === "benefitImage") {
        router.push(
          `benefitDetail?benefit_type=${props.item.productInfo[0].benefit_type}`
        );
      } else {
        router.push(`moreBenefit?open_page=${props.type}`);
      }
    };

    return { handleDraw, amount, disable };
  },
});
</script>

<style lang="less" scoped>
.benefit-wrap {
  padding: 0 12px;

  &.benefit-image {
    margin-top: 32px;
  }

  .title {
    font-weight: 600;
    font-size: 18px;
    color: #222222;
    line-height: 22px;
  }

  .desc {
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 16px;
    margin-top: 7px;
  }

  .content {
    position: relative;
    margin-top: 16px;
    width: 351px;
    height: 122px;
    border-radius: 8px;
    box-sizing: border-box;
    background-repeat: no-repeat !important;
    background-size: 100% !important;

    .action {
      width: 70px;
      position: absolute;
      bottom: 32px;
      top: 39px;
      right: 23px;

      .amount {
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        line-height: 16px;
        text-align: center;
      }
      .btn {
        width: 70px;
        height: 24px;
        background: linear-gradient(115deg, #dfbd94 0%, #ffe8c8 100%);
        border-radius: 13px;
        margin-top: 11px;
        font-weight: 500;
        font-size: 12px;
        color: #000000;
        line-height: 24px;
        text-align: center;

        &.disabled {
          background: #ccc;
          color: #fff;
        }
      }
    }
  }
}
</style>
